import Alpine from './alpine'

/**
 * The segment condition builder.
 *
 * Always keeps one blank row so adding the next condition is not a click on
 * "add" first. The server drops the blanks, so an untouched row is never
 * reported back as a validation error the merchant did not make.
 */
Alpine.data('segmentBuilder', (initial = []) => ({
    rows: [],

    /** Relations that are about presence, so a value would be ignored. */
    valueless: ['is_set', 'is_not_set'],

    init() {
        this.rows = (initial ?? []).map((row) => ({
            column: row.column ?? '',
            relation: row.relation ?? 'equals',
            condition: row.condition ?? '',
        }))

        this.ensureBlank()
    },

    add() {
        this.rows.push({ column: '', relation: 'equals', condition: '' })
    },

    remove(index) {
        this.rows.splice(index, 1)
        this.ensureBlank()
    },

    ensureBlank() {
        const last = this.rows[this.rows.length - 1]

        if (! last || last.column !== '') {
            this.add()
        }
    },

    needsValue(row) {
        return ! this.valueless.includes(row.relation)
    },
}))
